import { useEffect, useState } from 'react';
import SettingList from 'applications/signal/components/SettingList';
import { useSignalMonitoringSettings } from 'applications/signal/hooks/gqlHooks';
import FullScreenLoadCircle from 'applications/signal/components/FullScreenLoadCircle';
import { AlertSnackbarProps } from "features/components/alertSnackbar";
import { setGlobalMessage } from "hooks/useGlobalMessage";

export default function SettingIndex() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackBarMessage, setSnackBarMessage] = useState<AlertSnackbarProps | null>(null);

  const { data, fetching, error, fetchSignalMonitoringSettings} = useSignalMonitoringSettings();
  useEffect(() => {
    // snackbarMessageを依存配列に入れることで、保存後に再取得を行う
    fetchSignalMonitoringSettings({
      item_offset: page * rowsPerPage,
      per_page: rowsPerPage,
    });
  }, [page, rowsPerPage, snackBarMessage]);

  useEffect(() => {
    if (error) {
      setGlobalMessage({
        message: "Signalモニタリング設定の取得に失敗しました。",
        severity: "error",
      });
    }
  }, [error]);

  useEffect(() => {
    if (snackBarMessage) {
      setGlobalMessage(snackBarMessage);
    }
  }, [snackBarMessage]);

  return (
    <>
      {fetching ? <FullScreenLoadCircle /> : null}
      <SettingList
        rows={data?.getSignalMonitoringSettings?.settings || []}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalCount={data?.getSignalMonitoringSettings?.totalCount || 0}
        setSnackBarMessage={setSnackBarMessage}
      />
    </>
  )
}
